import ClockStatic from "./clock-static";

export default ClockStatic;